import * as React from "react";
import Carousel from "react-material-ui-carousel";

interface Props {
  media?: { url: string }[];
}

const MenuItemImages: React.FC<Props> = ({ media = [] }) => {
  if (media.length === 0) return null;

  return (
    <Carousel>
      {media.map((item, index) => (
        <img
          key={`carousel-image-${index}`}
          className="carousel-image"
          src={item.url}
          alt=""
        />
      ))}
    </Carousel>
  );
};

export default MenuItemImages;
